export * from './dynamic-page-config';
export * from './component-name';
